import { combineSlices } from '@reduxjs/toolkit';

import app from './app/app.slice';
import events from './events/events.slice';
import layout from './layout/layout.slice';
import tracking from './tracking/tracking.slice';
import marketingMeta from './marketingMeta/marketingMeta.slice';
import tokens from './tokens/tokens.slice';

declare global {
  interface LazyLoadedSlices {
    app: typeof app;
    events: typeof events;
    layout: typeof layout;
    tracking: typeof tracking;
    marketingMeta: typeof marketingMeta;
    tokens: typeof tokens;
  }
}

export default combineSlices({
  app,
  events,
  layout,
  tracking,
  marketingMeta,
  tokens,
}).withLazyLoadedSlices<LazyLoadedSlices>();
